<template>
  <div class="root">
    <div class="hh-profile-container margin-top-50">
      <Alert
        v-if="notification.message"
        :message="notification.message"
        :type="notification.type"
        ref="top"
        class="margin-top-10"
      />
      <div class="panel panel-default">
        <div class="container-fluid">
          <div
            v-if="loading"
            class="section-body margin-top-50 margin-bottom-50"
          >
            <LoadingAnimation />
          </div>
          <div class="section-body margin-bottom-50" v-if="dataAnalysed">
            
            <div class="d-flex margin-top-10 justify-content-center flex-direction-column">
             <div v-if="this.role === 'organizer'" class="col-md-12 text-center btn-footer">
                <a href="/fundraise" class="width-100">
                    <button type="button" class="button btn btn-hero btn-lg hh-btn-green btn-footer" name="Start a fundraiser">
                    <span class="font-18">
                      Start a Fundraiser
                    </span>
                    </button>
                </a>
            </div>
              <h1 class="account-title">
                {{ pageTitle }}
              </h1>
            </div>
            <div v-show="!loading" class="row" ref="profileImage">
              <label class="hh-input-label text-center">Profile Picture</label>
              <div class="row profile-image-container justify-content-center">
                <div
                  class="
                    col-sm-6
                    margin-bottom-20
                    d-flex
                    justify-content-center
                  "
                >
                  <ProfileImage
                    ref="profileImageComponent"
                    :image-src="userData.personalInformation.profile_image"
                    :endpoint="profileImageEndpoint"
                    @componentLoading="componentLoading"
                    size="small"
                  />
                </div>
              </div>
            </div>
            <div v-show="!loading" class="row margin-top-20">
              <div class="col-sm-12 form margin-bottom-30">
                <div
                  class="personal-information-section"
                  ref="personalInformation"
                >
                  <PersonalInformation
                    ref="personalInformationComponent"
                    :user-data="userData.personalInformation"
                    :edit-mode="false"
                    :identities="identities"
                    edit-information-route-name="personalInformation"
                    @componentLoading="componentLoading"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 form margin-bottom-30">
                <div class="payment-wrapper" ref="paymentInformation">
                  <div class="margin-bottom-20">
                    <PaymentInformation
                      ref="paymentInformationComponent"
                      :user-data="userData.paymentInformation"
                      :stripe-key="stripeKey"
                      :edit-mode="false"
                      :show-title="true"
                      :errors="errors"
                      edit-information-route-name="paymentInformation"
                      @componentLoading="componentLoading"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-show="!loading"
              v-if="role === 'organizer'"
              class="row margin-top-20"
            >
              <div class="col-sm-12 form margin-bottom-30">
                <div
                  class="personal-information-section"
                  ref="personalInformation"
                >
                  <PayoutInformation
                    ref="payoutInformationComponent"
                    :user-data="userData.payoutInformation"
                    :static-data="staticData"
                    :userRoles="userRoles"
                    :edit-mode="false"
                    :show-title="true"
                    :show-edit="true"
                    edit-information-route-name="payoutInformation"
                    @componentLoading="componentLoading"
                    :errors="errors"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import ProfileImage from "../../components/form/ProfileImage";
import PayoutInformation from "../../components/form/PayoutInformation";
import PersonalInformation from "../../components/form/PersonalInformation";
import PaymentInformation from "../../components/form/PaymentInformation";
import Address from "../../components/form/Address";
import Alert from "../../components/form/elements/Alert";
import LoadingAnimation from "../../components/LoadingAnimation";
import { scrollTop } from "../../utils/componentHelper";
import Form from "../../plugins/Form";

import constants from "../../config";

export default {
  name: "Account",

  components: {
    ProfileImage,
    PayoutInformation,
    PersonalInformation,
    PaymentInformation,
    Address,
    Alert,
    LoadingAnimation,
  },

  props: {},

  beforeMount() {
    if (_.isEmpty(this.profileData)) {
      this.fetchData().then(() => {
        this.analyseUserData();
      });
    } else {
      this.analyseUserData();
    }
  },

  mounted() {
    if (!_.isEmpty(this.alert)) {
      this.notification = this.alert;
      this.$store.commit("setAlert", null);
    }
  },

  data: () => {
    return {
      accountType: "Donor",
      profileImageEndpoint: constants.BASE_URL + "profile/profile-image",
      dataAnalysed: false,
      notification: {
        message: null,
        type: null,
      },
      componentsLoadingStatus: {
        ProfileImage: true,
        PersonalInformation: true,
        PaymentInformation: true,
        // ContactInformation: true,
      },
      config: {},
      userData: {
        personalInformation: {
          email: null,
          first_name: null,
          last_name: null,
          date_of_birth: null,
          phone: null,
        },
        paymentInformation: {
          name: null,
          last4: null,
          brand: null,
        },
        contactInformation: {
          billing_first_name: null,
          billing_last_name: null,
          billing_address_1: null,
          billing_address_2: null,
          billing_country: "United States",
          billing_city: null,
          billing_state: null,
          billing_zip: null,
        },
        payoutInformation: {
          business_name: null,
          business_type: null,
          url: null,
          identification_number: null,
          account_number: null,
          routing_number: null,
          status_label: 'Unknown',
        },
      },
      staticData: Object,
      userRoles: Array,
      identities: Array,
    };
  },

  methods: {
    ...mapActions("profile", ["fetchData"]),

    fillUserData() {
      this.userRoles = this.profileData.data.attributes.roles;
      this.identities = this.profileData.data.attributes.identities;

      this.fillPersonalInformation();
      this.fillPaymentInformation();
      this.fillContactInformation();
      this.fillPayoutInformation();
      this.fillStaticData();
    },

    fillPersonalInformation() {
      this.userData.personalInformation = {
        ...this.profileData.data.attributes,
      };
    },

    fillPaymentInformation() {
      if (!_.isEmpty(this.profileData.data.relations.paymentInformation)) {
        let paymentInformation =
          this.profileData.data.relations.paymentInformation[0].data.attributes;

        this.userData.paymentInformation = { ...paymentInformation };
      }
    },

    fillContactInformation() {
      if (!_.isEmpty(this.profileData.data.relations.contact)) {
        let contactData =
          this.profileData.data.relations.contact.data.attributes;

        this.userData.contactInformation = { ...contactData };
      }
    },

    fillPayoutInformation() {
      if (!_.isEmpty(this.profileData.data.relations.payoutInformation)) {
        let payoutInformation =
          this.profileData.data.relations.payoutInformation.data.attributes;

        this.userData.payoutInformation = { ...payoutInformation };
        this.userData.payoutInformation.business_name =
          this.profileData.data.attributes.business_name;
      }
    },

    fillStaticData() {
      if (!_.isEmpty(this.profileData.data.staticData)) {
        this.staticData = this.profileData.data.staticData;
      }
    },

    fillConfigData() {
      if (!_.isEmpty(this.profileData.config)) {
        this.config = this.profileData.config;
      }
    },

    checkForStripeUpdates() {
      if (_.isEmpty(this.notification.message) && this.role === "organizer") {
        if (
          this.userData.payoutInformation.status_label !== "Ok" &&
          this.userData.payoutInformation.status_label !== "Review" &&
          this.userData.payoutInformation.status_label !== "Unknown"
        ) {
          this.notification = {
            message:
              "Your account requires your attention. Please update your Bank Information.",
            type: "bg-warning",
          };
        }
      }
    },

    analyseUserData() {
      if (!_.isEmpty(this.profileData)) {
        this.fillUserData();
        this.fillConfigData();
        this.checkForStripeUpdates();
        this.dataAnalysed = true;
      }
    },

    componentLoading(componentName, value) {
      this.componentsLoadingStatus[componentName] = value;
    },

    mapAddressData(data, prefix) {
      return {
        firstName: data[`${prefix}_first_name`],
        lastName: data[`${prefix}_last_name`],
        address1: data[`${prefix}_address_1`],
        address2: data[`${prefix}_address_2`],
        country: data[`${prefix}_country`],
        city: data[`${prefix}_city`],
        state: data[`${prefix}_state`],
        zip: data[`${prefix}_zip`],
      };
    },
  },

  computed: {
    ...mapGetters("profile", ["profileData"]),
    ...mapGetters(["alert"]),

    pageTitle() {
      if (_.isEmpty(this.userRoles)) {
        return "Loading...";
      }

      if (this.userRoles.includes("organizer")) {
        this.accountType = "Fundraiser";
      }

      return `${this.accountType} Account`;
    },

    loading() {
      for (let component in this.componentsLoadingStatus) {
        if (this.componentsLoadingStatus[component]) {
          return true;
        }
      }

      return false;
    },

    role() {
      if (!_.isEmpty(this.userRoles) && this.userRoles.includes("organizer")) {
        return "organizer";
      }

      return "donor";
    },

    stripeKey() {
      if (_.isEmpty(this.config.stripe_key)) {
        return null;
      }

      return this.config.stripe_key;
    },

    mappedBillingAddressData() {
      return this.mapAddressData(this.userData.contactInformation, "billing");
    },

    errors() {
      return new Form({}).errors;
    },
  },
};
</script>

<style lang="scss" scoped>
.root::v-deep {
  @import "../../../style/pages/profile";
  @import "../../../style/components/forms";
}

.flex-direction-column {
  flex-direction: column;
}
</style>